import { Component, Vue } from 'vue-property-decorator'
import  elUpload  from 'element-ui/lib/upload';
import 'element-ui/lib/theme-chalk/upload.css';
import 'element-ui/lib/theme-chalk/icon.css';
Vue.component('el-upload',elUpload)
var XLSX = require('xlsx')
@Component
export default class addGoods extends Vue {
    api:any={
      addGoodsApi: "https://opc" + this.domain +"/ule-live-amdin/api/v1/room/good/add"
    }
    isClick:boolean = true
    goodsId:any = ''
    xlsxJson:any= {}
    importHeader:any=["id"]
    mounted() {

    }
    batchImport(file:any, fileList:any,header:any) {
      // let file = file.files[0] // 使用传统的input方法需要加上这一步
      const types = file.name.split(".")[1];
      const fileType = ["xlsx", "xlc", "xlm", "xls", "xlt", "xlw", "csv"].some(
        (item) => item === types
      );
      if (!fileType) {
        this.$toast({
          message: "格式错误！请重新选择",
          className: 'topIndex',
          duration: 3000
        });        
        return;
      }
      this.file2Xce(file,header).then((tabJson:any) => {
        if (tabJson && tabJson.length > 0) {
          this.xlsxJson = tabJson;
        }
        this.setLedgerList();
      });
    }
    setLedgerList() {
      let data:any = [];

      this.xlsxJson[0].sheet.forEach((item:any) => {
        if (item.id) {
          data.push(item.id);
        }
      });
      this.goodsId = data.join(',')
    //  这个data就可以传给后端，存入数据了
    }
    file2Xce(file:any,header:any) {
      return new Promise(function (resolve, reject) {
        const reader = new FileReader();
        reader.onload = function (e:any) {
          const data = e.target.result;
          // XLSX.read返回值为WorkBook对象，包含整个文件的所有表
          let  m:any =this
          m.wb = XLSX.read(data, {
            type: "binary",
          });
          const result:any = [];
          //SheetNames包含了文件中所有的表明
          m.wb.SheetNames.forEach((sheetName:any) => {
            result.push({
              sheetName: sheetName,
              sheet: XLSX.utils.sheet_to_json(m.wb.Sheets[sheetName], {
                //header是设置表属性名，如果设置为数字，则属性名由0，1，2...表示
                //此处设置的header为importHeader:["姓名","年龄"],最终结果的属性名对应该数组
                header: header,
              }),
            });
          });
          console.log(result)
          resolve(result);
        };
        reader.readAsBinaryString(file.raw);
        // reader.readAsBinaryString(file) // 传统input方法
      });
    }
    download(){
      window.location.href = `https://opc${this.domain}/ule-live-amdin/file/good-import-template.xlsx`
    }
    add(){
        if(!this.goodsId){
            this.$toast({
                message: '请输入要添加的商品ID,多个商品请用英文逗号隔开',
                className: 'topIndex',
                duration: 2000
            });
            return false
        }
        if (!this.isClick) {
          return false
        }else{
          this.isClick = false
          setTimeout(() => {
            this.isClick = true
          }, 3000);
        }
        this.fetch(
            {
                url: this.api.addGoodsApi,
                data: {
                  room_id: this.$route.params.id,
                  good_id:this.goodsId
                },
                method:'POST'
            }).then((data:any) => {
                this.$toast({
                    message: '添加商品成功',
                    className: 'topIndex',
                    duration: 2000
                });
                this.goodsId = '';
                this.$emit('updateGoods')
                this.close();
          }).catch((res:any)=>{
            this.$toast({
                message: res.data,
                className: 'topIndex',
                duration: 2000
            });
          })
    }
    close(){
      this.$emit('addGoodsSet',false)
    }
}


